var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ShowIf from "../../App/ShowIf";
import { Translate } from "../../I18N";
import { Icon } from "../../UI";

import { resetSearch } from "../actions/actions";

class ResetSearch extends Component {
  render() {
    const { connectionsGroups } = this.props;
    return /*#__PURE__*/(
      _jsx(ShowIf, { if: Boolean(connectionsGroups.size) }, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", onClick: this.props.resetSearch, className: "btn btn-default" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "times" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Clear Filters")
      )
      )
      ));

  }
}






function mapStateToProps({ relationships }) {
  return {
    connectionsGroups: relationships.list.connectionsGroups
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ resetSearch }, dispatch);
}

export { ResetSearch };

export default connect(mapStateToProps, mapDispatchToProps)(ResetSearch);